export default __webpack_public_path__ + "7f8e2b38952f3fe19089138249981b7f.png";